import { createAsyncThunk } from "@reduxjs/toolkit";
import { createThunkName } from "../redux/createThunkNamespace";
import type { ThunkBase } from "../redux/types";
import { setCloseEventReason, setConnectionStatus } from "./socketSlice";
import {
  type CloseEventReasonType,
  SocketStatus,
  type SocketStatusType,
} from "./webSocketStatus";

export const updateSocketConnectionStatusThunk = createAsyncThunk<
  void,
  SocketStatusType,
  ThunkBase
>(
  createThunkName("updateSocketConnectionStatusThunk"),
  async (status: SocketStatusType, { dispatch }) => {
    dispatch(setConnectionStatus(status));
  },
);

export const updateSocketCloseThunk = createAsyncThunk<
  void,
  CloseEventReasonType,
  ThunkBase
>(
  createThunkName("updateSocketCloseThunk"),
  async (reason: CloseEventReasonType, { dispatch }) => {
    dispatch(updateSocketConnectionStatusThunk(SocketStatus.CLOSED));
    dispatch(setCloseEventReason(reason));
  },
);
